<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<section>
<header>
<h1 class="FM-Head-fmh"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"><span href="#/xhtml/contents#c_aut" id="aut" title="Link target outside of Sample">Author’s Note and Acknowledgments</span></span></h1>
</header>
<p class="FMCO">All of the ancient Egyptian symbolism and Washington, D.C., architectural history in <i>Cut to the Bone</i> are real. Likewise, the neurological, medical, and psychological ideas presented here are based on real phenomena. Visit ellisoncooper.com to find out more.</p>
<p class="FMTX">I’d like to express my endless thanks to everyone who helped make <i>Cut to the Bone</i> happen.</p>
<p class="FMTX">I’m immensely grateful to my agent, Amy Tannenbaum, for everything she’s done. Thanks also to Jessica Errera and everyone at Jane Rotrosen Agency for being flat-out amazing in every way.</p>
<p class="FMTX">Thank you to my wonderful editor, Leslie Gelbman, and to everyone at St. Martin’s Press/Minotaur Books, including Tiffany Shelton, Hector DeJean, Alison Ziegler, Joe Brosnan, Paul Hochman, and Kelley Ragland.</p>
<p class="FMTX">Thank you to Megan Coen, my brainstorming partner and dear friend who never thinks my ideas are too dark.</p>
<p class="FMTX">Thanks to Theresa Iantosca for her sharp-eyed edits fixing all my mistakes! I raise a glass to the whole Curbside Crew, the best neighbors in the world.</p>
<p class="FMTX"><span aria-label="viii" id="pg_viii" role="doc-pagebreak">Finally, I can never thank my family enough for always encouraging me to pursue my dreams. As always, special thanks to my husband, Sean, my best friend, true love, and partner in crime.</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?2883e6d9